/**
 * The error every endpoint answers with when the API's response does not match the client's schema.
 *
 * `api.ts` hands it to RTK Query's `catchSchemaFailure`, which covers `responseSchema` and
 * `rawResponseSchema`. A `queryFn` that parses a response itself returns the same value, so a caller
 * sees one error whichever path validated the payload.
 */
export const SCHEMA_FAILURE_ERROR = {
  status: "CUSTOM_ERROR" as const,
  error: "API response did not match the expected schema.",
};
